import React, { useEffect, useReducer, useRef, useState } from 'react';
import { Grid, Box, Typography, Divider, } from '@mui/material';
import { CustomButton, CustomReactSelect } from '../../shared';
import { useDispatch, useSelector } from 'react-redux';
import { getCampaignIngestion, getSelectedCampaignPartners } from '../../../redux/thunks/campaignThunks';
import { actions } from '../../../redux/reducers/venderIntegrationReducer';
import { CrossCircleIcon } from '../../../assets';
import { createPartnerConnection, deletePartnerConnection, getPartnerConnections, resetAllConnectionselectedincspAs0, updatePartnerConnection } from '../../../redux/thunks/partnerThunk';
import Select, { components } from "react-select";
function VendorIntegrations(props) {
    const { } = props;
    const dispatch = useDispatch();
    const { company } = useSelector((state) => state.company);
    const { resetSuccess, partnerConnections } = useSelector((state) => state.partner)
    const { campaignGenerationType, partners } = useSelector((state) => state.campaign);
    const { vendorIntegration } = useSelector((state) => state.venderIntegration);
    const { vendorIntegrationData } = vendorIntegration;
    const [isDeleted, update] = useReducer((x) => x + 1, 0);
    const selectRefs = useRef([]);
    const [isOpen, setIsOpen] = useState(false);
    const vendorIntegrationDataLength = Object.keys(vendorIntegrationData)?.length;
    const callInitialApis = () => {
        dispatch(getPartnerConnections({ companyId: company.id }));
        dispatch(getSelectedCampaignPartners({ companyId: company.id }));
        dispatch(getCampaignIngestion({ companyId: company.id }));
    }

    const createConnectionOptions = (id) => {
        const options = [
            {
                label: 'New Connection',
                value: '',
                connection: {
                    id: null,
                    name: '',
                    partner_id: id,
                    selected_in_csp: '',
                    sftp_archive_path: '',
                    sftp_host: '',
                    sftp_path: '',
                    sftp_user: '',
                    selectedConnection: '',
                    sftp_password: '',
                    selected: 0
                }
            }
        ];

        if (partnerConnections.length > 0) {
            partnerConnections?.forEach(connection => {
                if (id === connection?.partner_id) {
                    options.push({
                        label: connection?.name,
                        value: connection?.id,
                        connection: [connection],
                    });
                }
            });
        }
        return options;
    };
    const handleConnection = (category, selectedOption) => {
        dispatch(actions.handleConnection({ category: category, selectedOption: selectedOption }))
    };
    const handleInputChange = (id, category, field, value) => {
        dispatch(actions.handleInputChange({ category: category, category: category, field: field, value: value }))
    };
    const handleRemoveConnection = (value, label) => {
        dispatch(deletePartnerConnection({ companyId: company.id, connectionId: value })).then(result => {
            if (result.payload.status_code === 200) {
                update()
            }
        })
    }

    const handleSave = () => {
        dispatch(resetAllConnectionselectedincspAs0({ companyId: company.id })).then(result => {
            if(result.payload.status_code === 200){
                saveConnections();
            }
        })
    }

    useEffect(() => {
        if (company.id) {
            callInitialApis()
        }
    }, [company.id, dispatch, isDeleted])
    useEffect(() => {
        if (company.id) {
            if (partners.length > 0) {
                dispatch(actions.createVendorIntegrationData({ selectedPartners: partners, connections: partnerConnections }));
            }
        }
    }, [company.id, partners,partnerConnections])


  const saveConnections = () =>{
    const updateConnections = Object.entries(vendorIntegrationData).filter(([key, connection]) => connection.id && connection.selected === 1);
    if (updateConnections && updateConnections.length) {
        updateConnections.forEach(([key, partnerConnection]) => {
            const data = {
                ...partnerConnection,
                selected_in_csp: 1
            }
            dispatch(updatePartnerConnection({ companyId: company.id, partnerConnectionId: partnerConnection.id, data: data })).then(result => {
                if (result.payload.status_code === 200) {
                    dispatch(getPartnerConnections({ companyId: company.id }));
                }
            })
        });
    }
    const newConnections = Object.entries(vendorIntegrationData).filter(([key, connection]) => connection.id === (null || "") && connection.selected === 1);
    if (newConnections && newConnections.length) {
        newConnections.forEach(([key, partnerConnection]) => {
            const data = {
                ...partnerConnection,
                selected_in_csp: 1
            }
            dispatch(createPartnerConnection({ companyId: company.id, data: data })).then(result => {
                if (result.payload.status_code === 200) {
                    dispatch(getPartnerConnections({ companyId: company.id }));
                }
            })
        });
    }
}
  
            


    return (
        <>
            {
                campaignGenerationType === "ALGORITHM" ?
                    <Grid
                        container
                        className="flex-row"
                    >
                        {/* Vendor Integrations */}
                        <Grid item xs={12}>
                            <Box className="flex-column gap-4">
                                <Typography className="text-lg-medium gray-900">
                                    Establish In-scope Vendor Integrations
                                </Typography>
                            </Box>
                            <Divider className='mv-24 border-1-gray' />

                            {Object.keys(vendorIntegrationData)?.map((category, index) => {
                                const {
                                    id,
                                    name,
                                    partner_id,
                                    selected_in_csp,
                                    sftp_archive_path,
                                    sftp_host,
                                    sftp_path,
                                    sftp_user,
                                    selectedConnection,
                                    sftp_password,
                                } = vendorIntegrationData[category];

                                let connection = selectedConnection;
                                const options = createConnectionOptions(partner_id);

                                return (<Box className="flex-column gap-16" key={index}>
                                    <Typography className='text-md-medium gray-700'>
                                        {category}
                                    </Typography>
                                    <Box className='flex-row-end-center pb-24px gap-8'>
                                        <Box className="w-25" key={index} ref={(el) => (selectRefs.current[index] = el)}>
                                        <CustomReactSelect
                                                options={options}
                                                handleFilter={handleConnection}
                                                placeholder='Connection'
                                                selectedOption={options?.find(item => {
                                                    if (connection !== '') {
                                                        return item.label === connection
                                                    }
                                                    return {}
                                                }
                                                )}
                                                formatOptionLabel={({ value, label, }) => (
                                                    <div className='d-flex align-items-center'>
                                                        <div className='flex-1'>{label}</div>
                                                        {label != "New Connection" ?
                                                            <div onClick={() => handleRemoveConnection(value, label)} className='select-remove-button d-flex justify-content-center align-items-center' >x</div>
                                                            : null}
                                                    </div>
                                                )}
                                                index={category}
                                            />

                                        </Box>
                                        <Box>
                                            <input
                                                type="text"
                                                placeholder='Connection Name'
                                                className='custom-text-field text-sm-regular'
                                                value={name}
                                                autoComplete='off'
                                                onChange={(e) => handleInputChange(partner_id, category, 'name', e.target.value)}
                                            />
                                        </Box>
                                        <Box>
                                            <input
                                                type="text"
                                                placeholder='Host'
                                                className='custom-text-field text-sm-regular'
                                                value={sftp_host}
                                                autoComplete='off'
                                                onChange={(e) => handleInputChange(partner_id, category, 'sftp_host', e.target.value)}
                                            />
                                        </Box>
                                        <Box>
                                            <input
                                                type="text"
                                                placeholder='User'
                                                className='custom-text-field text-sm-regular'
                                                value={sftp_user}
                                                autoComplete='off'
                                                onChange={(e) => handleInputChange(partner_id, category, 'sftp_user', e.target.value)}
                                            />
                                        </Box>
                                        <Box>
                                            <input
                                                type="password"
                                                placeholder='Password'
                                                className='custom-text-field text-sm-regular'
                                                value={sftp_password}
                                                autoComplete="new-password"
                                                onChange={(e) => handleInputChange(partner_id, category, 'sftp_password', e.target.value)}
                                            />
                                        </Box>
                                        <Box>
                                            <input
                                                type="text"
                                                placeholder='Path'
                                                className='custom-text-field text-sm-regular'
                                                value={sftp_path}
                                                autoComplete='off'
                                                onChange={(e) => handleInputChange(partner_id, category, 'sftp_path', e.target.value)}
                                            />
                                        </Box>
                                        <Box>
                                            <input
                                                type="text"
                                                placeholder='Active Path'
                                                className='custom-text-field text-sm-regular'
                                                value={sftp_archive_path}
                                                autoComplete='off'
                                                onChange={(e) => handleInputChange(partner_id, category, 'sftp_archive_path', e.target.value)}
                                            />
                                        </Box>
                                    </Box>
                                </Box>)
                            }
                            )}
                        </Grid>

                        <Grid item xs={12} >
                            <Divider className='border-1-gray margin-tb-0-rl-32' />
                            <Box className="flex-row-end-center padding-tb-16-rl-24">
                                <CustomButton
                                    title="Save"
                                    titleColor="#FFFFFF"
                                    buttonColor="#AD509E"
                                    handleClick={() => handleSave()}
                                />
                            </Box>
                        </Grid>
                    </Grid> :
                    <Box className="box-sizing-border-box border-1-gray br-8px flex-row-center" height={200}>
                        <Typography className="text-lg-medium gray-900 text-center">
                            Please choose Campaign Generation Type as "ALGORITHM" to see the Vendor Integrations details.
                        </Typography>
                    </Box>
            }
        </>
    )
}

export default VendorIntegrations;